import "./App.css";
import "react-toastify/dist/ReactToastify.css";
import { Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "./components/navbar/Navbar";
import HomePage from "./pages/HomePage";
import TrendingNews from "./pages/TrendingNews";
import AddManager from "./pages/AddManager";
import ManagerReview from "./pages/ManagerReview";
import CompanyProfile from "./pages/CompanyProfile";
import ManagerProfile from "./pages/ManagerProfile";
import Legalguidelines from "./pages/Legalguidelines";
import ContactUs from "./pages/ContactUs";
import Termsofuse from "./pages/Termsofuse";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import AllReviews from "./pages/AllReviews";
import AddReview from "./pages/AddReview";
import CompanyReviews from "./pages/CompanyReviews";
import ViewAllManagers from "./pages/ViewAllManagers";
import VerifyHandler from "./pages/VerifyHandler";
import VerifyUpdatedEmail from "./pages/VerifyUpdatedEmail";
import ResetPasswordHandler from "./pages/ResetPasswordHandler";
import { ToastContainer } from "react-toastify";
import { clearUserData } from "./features/user/userSlice";
import { useDispatch } from "react-redux";
import Preference from "./pages/Preference";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const UTMParameterManager = () => {
  const location = useLocation();

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const utmSource = urlParams.get('utm_source');
    if (utmSource) {
      localStorage.setItem('utm_source', utmSource);
    }
  }, [location.search]);

  return null;
};

function TokenExpiryManager() {
  const dispatch = useDispatch();
  useEffect(() => {
    const token = localStorage.getItem("token");
    const expiry = localStorage.getItem("tokenExpiry");
    if (token && expiry) {
      const now = Date.now();
      const timeLeft = parseInt(expiry, 10) - now;
      if (timeLeft <= 0) {
        localStorage.removeItem("token");
        localStorage.removeItem("tokenExpiry");
        dispatch(clearUserData());
      } else {
        const id = setTimeout(() => {
          localStorage.removeItem("token");
          localStorage.removeItem("tokenExpiry");
          dispatch(clearUserData());
        }, timeLeft);
        return () => clearTimeout(id);
      }
    }
  }, [dispatch]);
  return null;
}

export default function App() {
  return (
    <>
      <ScrollToTop />
      <UTMParameterManager />
      <TokenExpiryManager />
      <ToastContainer position="top-right" autoClose={3000} />
      <Navbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/trending-news" element={<TrendingNews />} />
        <Route path="/add-manager-profile" element={<AddManager />} />
        <Route path="/submit-manager-review" element={<ManagerReview />} />
        <Route path="/company-profile" element={<CompanyProfile />} />
        <Route path="/manager" element={<ManagerProfile />} />
        <Route path="/manager-profile" element={<ManagerProfile />} />
        <Route path="/legal-guidelines" element={<Legalguidelines />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/terms-of-use" element={<Termsofuse />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/all-reviews" element={<AllReviews />} />
        <Route path="/add-review" element={<AddReview />} />
        <Route path="/company-reviews" element={<CompanyReviews />} />
        <Route path="/view-all-managers" element={<ViewAllManagers />} />
        <Route path="/verify" element={<VerifyHandler />} />
        <Route path="/verify_updated_email" element={<VerifyUpdatedEmail />} />

        <Route path="/preference" element={<Preference />} />

        {/* Support both /new_password?token=... and /new_password/:token */}
        <Route path="/new_password" element={<ResetPasswordHandler />} />
        <Route path="/new_password/:token" element={<ResetPasswordHandler />} />
      </Routes>
    </>
  );
}
